module.exports = __webpack_public_path__ + "static/et-25660bdd1cfcfdd45cb2876225c782a9.jpg";